import { t } from "ttag";

import { MetabotSlackSetup } from "metabase/admin/ai/MetabotSlackSetup";
import { SettingsPageWrapper } from "metabase/admin/components/SettingsSection";
import { usePageTitle } from "metabase/hooks/use-page-title";
import { Icon } from "metabase/ui";

import { SlackSetup } from "../../slack/SlackSetup";

export const SlackSettingsPage = () => {
  usePageTitle(t`Slack`, { titleIndex: 1 });

  return (
    <>
      <SettingsPageWrapper
        title={
          <>
            <Icon name="slack_colorized" size={22} mr="sm" /> {t`Slack`}
          </>
        }
      >
        <SlackSetup />
        <MetabotSlackSetup />
      </SettingsPageWrapper>
    </>
  );
};
